import loadView from "@/utils/load-view";

const routes = [
    {
        path: "/team/settings",
        redirect: "/team/settings/account", // Automatically redirect to basic settings screen
        name: "AdminSettings",
        component: loadView("AdminSettings"),
        meta: {
            authRequired: true,
        },
        children: [
            {
                path: "/team/settings/billing",
                name: "AdminSettingsBilling",
                component: loadView("AdminSettingsBilling"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "teams/current/getInvoices" }),
                        () => ({ type: "teams/current/getInvoiceQuantity" }),
                    ],
                },
            },
            {
                path: "/team/settings/account",
                name: "AdminSettingsAccount",
                component: loadView("AdminSettingsAccount"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/reviews",
                name: "AdminSettingsReviews",
                component: loadView("AdminSettingsReviews"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
            },
            {
                path: "/team/settings/goals",
                name: "AdminSettingsGoals",
                component: loadView("AdminSettingsGoals"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "tags/tags/getList", payload: { type: ["goals"] } }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
            },
            {
                path: "/team/settings/learning",
                name: "AdminSettingsLearning",
                component: loadView("AdminSettingsLearning"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
            },
            {
                path: "/team/settings/feedback",
                name: "AdminSettingsFeedback",
                component: loadView("AdminSettingsFeedback"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "feedback/praiseWall/getSettings", payload: {} }),
                        () => ({ type: "feedback/badges/getList", payload: {} }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
                children: [
                    {
                        path: "/team/settings/feedback/badge/create",
                        name: "AdminSettingsFeedbackBadgeCreate",
                        component: loadView("AdminSettingsFeedbackBadgeCreate"),
                        meta: {
                            authRequired: true,
                            modal: true,
                        },
                    },
                    {
                        path: "/team/settings/feedback/badge/edit/:id",
                        name: "AdminSettingsFeedbackBadgeEdit",
                        component: loadView("AdminSettingsFeedbackBadgeEdit"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "feedback/badges/get",
                                    payload: { id: to.params.id },
                                }),
                            ],
                        },
                    },
                    {
                        path: "/team/settings/feedback/badge/delete/:id",
                        name: "AdminSettingsFeedbackBadgeDelete",
                        component: loadView("AdminSettingsFeedbackBadgeDelete"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "feedback/badges/get",
                                    payload: { id: to.params.id },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/team/settings/meetings",
                name: "AdminSettingsMeetings",
                component: loadView("AdminSettingsMeetings"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "meetings/sections/getList", payload: {} }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
            },
            {
                path: "/team/settings/notifications",
                name: "AdminSettingsNotifications",
                component: loadView("AdminSettingsNotifications"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "notifications/adminDashboard/getNotificationTypes",
                            payload: {},
                        }),
                    ],
                },
            },
            {
                path: "/team/settings/surveys",
                name: "AdminSettingsSurveys",
                component: loadView("AdminSettingsSurveys"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({ type: "tags/tags/getList", payload: { type: ["surveys"] } }),
                        () => ({ type: "users/location/getList" }),
                    ],
                },
            },
            {
                path: "/team/settings/slack",
                name: "AdminSettingsSlack",
                component: loadView("AdminSettingsSlack"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/msteams",
                name: "AdminSettingsMsteams",
                component: loadView("AdminSettingsMsteams"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/slackSuccess",
                name: "AdminSettingsSlackSuccess",
                component: loadView("AdminSettingsSlack"),
                props: {
                    success: true,
                    error: false,
                },
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/slackError",
                name: "AdminSettingsSlackError",
                component: loadView("AdminSettingsSlack"),
                props: {
                    success: false,
                    error: true,
                },
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/sso",
                name: "AdminSettingsSSO",
                component: loadView("AdminSettingsSSO"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/bamboo",
                redirect: "/team/settings/provisioning/bamboo",
            },
            {
                path: "/team/settings/scim",
                redirect: "/team/settings/provisioning/scim",
            },
            {
                path: "/team/settings/personio",
                redirect: "/team/settings/provisioning/personio",
            },
            {
                path: "/team/settings/hibob",
                redirect: "/team/settings/provisioning/hibob",
            },
            {
                path: "/team/settings/provisioning",
                redirect: "/team/settings/provisioning/personio",
            },
            {
                path: "/team/settings/provisioning/:currentView",
                name: "AdminSettingsHRIS",
                component: loadView("AdminSettingsHRIS"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/provisioning/:currentView/:status",
                name: "AdminSettingsHRIS",
                component: loadView("AdminSettingsHRIS"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/provisioning/:currentView/auth/:code",
                name: "AdminSettingsHRISAuth",
                props: true,
                component: loadView("AdminSettingsHRIS"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "teams/current/get", payload: { cache: true } })],
                },
            },
            {
                path: "/team/settings/jira",
                name: "AdminSettingsJira",
                component: loadView("AdminSettingsJira"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "teams/current/get", payload: { cache: true } }),
                        () => ({
                            type: "teams/current/getJiraAuthInit",
                        }),
                    ],
                },
            },
            {
                path: "/team/settings/api",
                name: "AdminSettingsAPI",
                component: loadView("AdminSettingsAPI"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "api/secret/getTokens" })],
                },
            },
        ],
    },
];

export default routes;
